import { ErsLifecycleActionsEnum } from '@app/modules/ers/modals/ers-lifecycle-modal/ers-lifecycle-modal.model';
import {
	ErsStatus,
	ErsVariant
}                                  from '@app/modules/ers/models/ers.model';
import { ErsState }                from '@app/modules/ers/store/ers.state';
import { ImportTypeEnum }          from '@app/modules/structure-import/models/structure-import.model';
import {
	ActionType,
	ActionTypeWithProps
}                                  from '@core/interfaces/store.interface';
import {
	adapterActions,
	IAdapterActions,
	IBaseProps
}                                  from '@core/store/adapter/adapter.actions';
import {
	createAction,
	props
}                                  from '@ngrx/store';
import {
	IChangeStatusCallback,
	IChangeStatusErsCallbackOptions
}                                  from '@shared/components/status-flow/status-flow.model';

export interface IErsActions extends IAdapterActions<ErsVariant> {
	checkAndUpdateEntityState: ActionTypeWithProps<IPropsErsEntity>;
	create: ActionType;
	showErsLifecycle: ActionTypeWithProps<PropsErsLifecycleType>;
	structureImportForErs: ActionTypeWithProps<IPropsStructureImportForErs>;
	updateBusinessPremisesActionItemsState: ActionTypeWithProps<IPropsUpdateBusinessPremisesActionItemsState>;
	updateErsState: ActionTypeWithProps<IPropsUpdateErsState>;
}


export interface IPropsChangeStatusErsEntity extends IBaseProps, IChangeStatusCallback {
	callbackOptions: IChangeStatusErsCallbackOptions;
	targetStatus: ErsStatus;
}

export interface IPropsErsLifecycleActivate extends IPropsChangeStatusErsEntity {
	lifecycleAction: ErsLifecycleActionsEnum.ACTIVATE;
}

export interface IPropsErsLifecycleDisable extends IPropsChangeStatusErsEntity {
	lifecycleAction: ErsLifecycleActionsEnum.DISABLE;
}

export type PropsErsLifecycleType =
	IPropsErsLifecycleActivate
	| IPropsErsLifecycleDisable;


export interface IPropsErsEntity extends IBaseProps {
	ers: ErsVariant;
}

export interface IPropsStructureImportForErs extends IBaseProps {
	importType: ImportTypeEnum.ERS | ImportTypeEnum.ERS_EXTERNAL;
}

export interface IPropsUpdateBusinessPremisesActionItemsState extends IBaseProps {
	businessPremisesId: string;
}

export interface IPropsUpdateErsState extends IBaseProps {
	stateUpdateData?: ErsState;
}

export function ersActions( storeId: string ) {
	return {
		// AdapterActions ##########################################################################################################################
		...adapterActions<ErsVariant>( storeId ),

		// ERS SPECIFIC ACTIONS ###########################################################################################################
		checkAndUpdateEntityState: createAction( `[${ storeId }] checkAndUpdateEntityState`, props<IPropsErsEntity>() ),
		create: createAction( `[${ storeId } ENTITY ACTION] Create` ),
		showErsLifecycle: createAction( `[${ storeId } ENTITY ACTION] Ers Lifecycle`, props<PropsErsLifecycleType>() ),
		structureImportForErs: createAction( `[${ storeId } ENTITY ACTION] StructureImport`, props<IPropsStructureImportForErs>() ),
		updateErsState: createAction( `[${ storeId } ENTITY ACTION] State Update`, props<IPropsUpdateErsState>() ),
		updateBusinessPremisesActionItemsState: createAction(
			`[${ storeId }] updateBusinessPremisesActionItemsState`,
			props<IPropsUpdateBusinessPremisesActionItemsState>()
		)
	};
}

